// 医生列表表头
export let lifeExperiencePavilionTableLabels = [
  {
    label: '体验馆名称',
    value: 'name'
  },
  {
    label: '地区',
    value: 'department'
  },
  {
    label: '所属分/子公司',
    value: 'organizationName'
  },
  {
    label: '创建时间',
    value: 'currentCreatedDate'
  }
]
